<template>
    <div class="mc-menu-content">
        <slot></slot>
    </div>
</template>

<style scoped lang="scss">
.mc-menu-content {
    background-color: #0c0f0c;
    padding: 5px;
}
</style>
